module.exports = __webpack_public_path__ + "img/wings_phuket_villa.566f524d.jpg";